/**
 * @generated SignedSource<<fb075adf0fd4f18faf3a24cffe276deb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsCta_user$data = {
  readonly addressBook: {
    readonly personalAddress: {
      readonly country: string | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsModal_user">;
  readonly " $fragmentType": "DisplaySettingsCta_user";
};
export type DisplaySettingsCta_user$key = {
  readonly " $data"?: DisplaySettingsCta_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsCta_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsCta_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DisplaySettingsModal_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "773b8d5450d98fabe3eda5cbc9923d20";

export default node;
